import {detect} from 'detect-browser';

// After the first check, the chrome api is polyfiled for safari -> cache the first result
let isSafariCache;
export function isSafari() {
	if (isSafariCache === undefined) {
		if (!('chrome' in window)) {
			if ('safari' in window) {
				isSafariCache = true;
				return true;
			}
			else {
				isSafariCache = false;
			}
		}
		else {
			isSafariCache = false;
		}
	}

	return isSafariCache;
}

export function isFirefox() {
	let browser = detect();
	return browser && browser.name && browser.name === "firefox";
}
